<pr-status-label
  class="w-20"
  [dense]="dense"
  [label]="status"
  [color]="status | map: statusColor"
/>
